import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useHistory } from "react-router-dom";
import { connect, useDispatch } from 'react-redux';
import i18n from 'utils/I18n';
import compareVersions from 'compare-versions';
import CustomAlert from 'component/base/CustomAlert';
import { detectIsMobileByScreenWidth } from 'utils/ScreenUtils';
import { defaultHeaderConfig, headerConfig } from 'frontend_common/HeaderConfig';
import LogoComponent from './LogoComponent';
import LeftComponent from './LeftComponent';
import CenterComponent from './CenterComponent';
import RightComponent from './RightComponent';
import { openLoginPage } from "utils/SSOUtil"
import './Navigator.scss';
import { navigateBackHomePage } from 'utils/WeChatUtil'

const { detect } = require('detect-browser');
const browser = detect();
const minBrowserVersions = {
  chrome: '83',
  firefox: '78',
  ie: '11',
  safari: '12.1',
};

const Navigator = ({
  language,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const navBarRef = useRef();

  const [navBarConfig, setNavBarConfig] = useState({});
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const isMobileView = detectIsMobileByScreenWidth();

  const loginOnClick = () => {
    openLoginPage({locale: i18n.language || 'en' })
  };

  const logoutOnClick = () => {
    setShowLogoutDialog(true);
  };

  const logoutCancel = () => {
    setShowLogoutDialog(false);
  };

  const logoutConfirm = () => {
    dispatch({
      type: 'users/logout',
      payload: {},
    });
    setShowLogoutDialog(false);
    navigateBackHomePage({ history })
  };


  const preventTouchMove = (event) => {
    if (event.cancelable) {
      event.preventDefault();
    };
  };

  useEffect(() => {
    navBarRef.current.addEventListener('touchmove', preventTouchMove, {
      passive: false,
    });

    return () => {
      navBarRef.current.removeEventListener('touchmove', preventTouchMove, {
        passive: false,
      });
    }
  }, []);

  useEffect(() => {
    if (location.pathname !== '/browser-support') {
      if (!browser) {
        history.push('/browser-support');
      } else if (minBrowserVersions[browser.name]) {
        if (
          compareVersions(browser.version, minBrowserVersions[browser.name]) < 0
        ) {
          history.push('/browser-support');
        }
      }
    };

    let config = defaultHeaderConfig;
    headerConfig.forEach(item => {
      if (location.pathname.indexOf(item.pathname) !== -1) {
        config = item;
      };
    });
    setNavBarConfig(config);
  }, [location]);

  if (location.pathname.indexOf('/unsubscribe_email') !== -1) {
    return (
      <div className="nav_container" ref={navBarRef}>
        <LogoComponent
          isMobile={isMobileView}
          isCenter={navBarConfig.headerLogoCenter}
        />
      </div>
    );
  }

  return (
    <div className="nav_container subheading" ref={navBarRef}>
      <LeftComponent
        navBarConfig={navBarConfig}
        isMobile={isMobileView}
      />
      <div className='nav-center-right-container'>
        <CenterComponent
          navBarConfig={navBarConfig}
          isMobile={isMobileView}
        />
        <RightComponent
          navBarConfig={navBarConfig}
          isMobile={isMobileView}
          loginOnClick={loginOnClick}
          logoutOnClick={logoutOnClick}
        />
      </div>
      <CustomAlert
        show={showLogoutDialog}
        onHide={logoutCancel}
        message={i18n.t('confirm_log_out')}
        leftbtn={i18n.t('log_out_cancel')}
        leftAction={logoutCancel}
        rightbtn={i18n.t('log_out')}
        rightAction={logoutConfirm}
        isLoading={false}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  language: state.users.language,
});

export default connect(mapStateToProps)(Navigator);
